
// ROUTES
require('modules/campaign/routes/campaign');

// CONTROLLERS
require('modules/campaign/controllers/campaign');
require('modules/campaign/controllers/list');
require('modules/campaign/controllers/create');
require('modules/campaign/controllers/edit');
require('modules/campaign/controllers/assign');


// SERVICES
require('modules/campaign/services/campaign');
require('modules/campaign/services/list');
require('modules/campaign/services/create');
require('modules/campaign/services/edit');
require('modules/campaign/services/delete');
require('modules/campaign/services/assign');
require('modules/campaign/services/send');



angular.module('unica_campaign', [

	// ROUTES
	'unica_campaign.campaign_routes',

	// CONTROLLERS
	'unica_campaign.campaign_controllers',

	// SERVICES
	'unica_campaign.campaign_services'

]);